
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import Value from '../../../examples/DataGrid/Value';
import srcValue from '../../../examples/DataGrid/Value?raw';
import Alignment from '../../../examples/DataGrid/Alignment';
import srcAlignment from '../../../examples/DataGrid/Alignment?raw';
import Flex from '../../../examples/DataGrid/Flex';
import srcFlex from '../../../examples/DataGrid/Flex?raw';
import Pinned from '../../../examples/DataGrid/Pinned';
import srcPinned from '../../../examples/DataGrid/Pinned?raw';
import Weather from '../../../examples/DataGrid/Weather';
import srcWeather from '../../../examples/DataGrid/Weather?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "columns.mdx",
    route: "/components/DataGrid/columns",
    meta: {
      "title": "Columns"
    },
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"DataGrid Columns"}</h1><p>{"Columns are defined as an array of "}<inlineCode parentName="p">{"ColumnDefinitions"}</inlineCode>{". Several options are available to describe how cell content needs to be rendered. All columns definitions require a unique (per table) "}<inlineCode parentName="p">{"key"}</inlineCode>{" property that unambiguously identifies it."}</p><h2>{"Value Selection"}</h2><p>{"By default, a cell's value is determined from the property in the data that corresponds to the "}<inlineCode parentName="p">{"key"}</inlineCode>{" in the column definition. This can optionally be overriden with the "}<inlineCode parentName="p">{"getValue"}</inlineCode>{" getter that allows you to select or compute a value based on a row."}</p>{"\n"}<CodeExample src={srcValue} mdxType="CodeExample"><Value parentName="CodeExample" mdxType="Value" /></CodeExample><h2>{"Alignment"}</h2><p>{"Use the "}<inlineCode parentName="p">{"align"}</inlineCode>{" property to justify content at either edge of a cell, or to the center."}</p>{"\n"}<CodeExample src={srcAlignment} mdxType="CodeExample"><Alignment parentName="CodeExample" mdxType="Alignment" /></CodeExample><h2>{"Flex"}</h2><p>{"If the columns take up less space than available, you can make them flex to fill up the available space. Use a "}<inlineCode parentName="p">{"flex"}</inlineCode>{" property on the column definition to specify how much of the available space you want to allocate to the column. This number is a unitless number that specifies the feaction of available space that this column will take. Resizing a column removes its ability to flex."}</p>{"\n"}<CodeExample src={srcFlex} mdxType="CodeExample"><Flex parentName="CodeExample" mdxType="Flex" /></CodeExample><h2>{"Pinned Columns"}</h2><p>{"Use the "}<inlineCode parentName="p">{"pin"}</inlineCode>{" property to pin columns at the start or end of the grid. It is possible to pin multiple columns at either side of the grid."}</p>{"\n"}<CodeExample src={srcPinned} mdxType="CodeExample"><Pinned parentName="CodeExample" mdxType="Pinned" /></CodeExample><h2>{"Custom Content"}</h2><p>{"Use the "}<inlineCode parentName="p">{"renderContent"}</inlineCode>{" option to gain more control over what exactly gets rendered in a cell. This works exactly like a render prop and you can return any valid react node from it."}</p>{"\n"}<CodeExample src={srcWeather} mdxType="CodeExample"><Weather parentName="CodeExample" mdxType="Weather" /></CodeExample></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
